import React, { Dispatch } from 'react'
import { IPartyNumberMap } from '../../models/TypeHelper'
import { IRegionalPollMap } from '../../App'
import NationalPolls from './NationalPolls'
import RegionalPolls from './RegionalPolls'
import RegionalResult from '../../models/RegionalResult'
import { resultForKey } from '../../controllers/DataController'
import { connect } from 'react-redux'
import {
  IReduxAction,
  IReduxState,
  PollsToShow,
  PredictionModel
} from '../../utils/ReduxStore'

import './PollsTab.scss'

import { compareResultKeys } from '../../controllers/ElectionResultStore'

interface IDispatchProps {
  projectFromPolls: (polls: IPartyNumberMap) => void
  projectFromRegionalPolls: (regionalPolls: IRegionalPollMap) => void
}

interface IStateProps {
  baseResultKey: string
  compareResultKey: string
  predictionModel: PredictionModel
  lastReset: number
}

interface IProps extends IDispatchProps, IStateProps {
  pollsToShow: PollsToShow
}

interface IState {
  // outcomes: PartyResultMap[]
  polls: IPartyNumberMap
  regionalPolls: IRegionalPollMap
}

class PollsTab extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)
    this.state = {
      polls: {},
      regionalPolls: {}
    }
    this.handlePollingUpdate = this.handlePollingUpdate.bind(this)
    this.handleRegionalPollingUpdate = this.handleRegionalPollingUpdate.bind(
      this
    )
  }

  public componentDidUpdate(prevProps: IProps): void {
    if (prevProps.lastReset !== this.props.lastReset) {
      this.setState({
        polls: {},
        regionalPolls: {}
      })
    } else if (
      !compareResultKeys(prevProps.baseResultKey, this.props.baseResultKey) ||
      !compareResultKeys(
        prevProps.compareResultKey,
        this.props.compareResultKey
      )
    ) {
      if (this.props.pollsToShow === 'nationalSlider') {
        if (Object.keys(this.state.polls).length)
          this.props.projectFromPolls(this.state.polls)
      } else {
        if (Object.keys(this.state.regionalPolls).length)
          this.props.projectFromRegionalPolls(this.state.regionalPolls)
      }
    }
  }

  protected handlePollingUpdate(polls: IPartyNumberMap): void {
    this.setState({ polls })
    this.props.projectFromPolls(polls)
  }

  protected handleRegionalPollingUpdate(polls: IRegionalPollMap): void {
    this.setState({ regionalPolls: polls })
    this.props.projectFromRegionalPolls(polls)
  }

  public nationalPolls(): IPartyNumberMap {
    return resultForKey(
      this.props.compareResultKey
    ).partyResultMap.votePercents()
  }

  public regionalPolls(): IRegionalPollMap {
    const regionalPolls: IRegionalPollMap = {}
    resultForKey(this.props.compareResultKey)
      .regionalResults()
      .forEach((regionalResult: RegionalResult): void => {
        regionalPolls[
          regionalResult.region.key
        ] = regionalResult.partyResultMap.votePercents()
      })
    return regionalPolls
  }

  public render(): JSX.Element {
    const showNational = this.props.pollsToShow === 'nationalSlider'
    return (
      <div className={`PollsTab col-12`}>
        <div className="row d-flex align-items-top">
          <div className="col-12 polls">
            {showNational ? (
              <NationalPolls
                annotations
                lastReset={this.props.lastReset}
                polls={this.nationalPolls()}
                handlePollingUpdate={this.handlePollingUpdate}
                predictionModel={this.props.predictionModel}
              />
            ) : (
              <RegionalPolls
                lastReset={this.props.lastReset}
                regionalPolls={this.regionalPolls()}
                handlePollingUpdate={this.handleRegionalPollingUpdate}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IReduxState): IStateProps => ({
  baseResultKey: state.baseResultKey,
  compareResultKey: state.compareResultKey,
  predictionModel: state.predictionModel,
  lastReset: state.lastReset
})

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  projectFromPolls: (polls: IPartyNumberMap): void => {
    dispatch({
      type: 'PROJECT_FROM_POLLS',
      polls
    })
  },
  projectFromRegionalPolls: (regionalPolls: IRegionalPollMap): void => {
    dispatch({
      type: 'PROJECT_FROM_REGIONAL_POLLS',
      polls: regionalPolls
    })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PollsTab)
